module.exports = "/1/5-nhap-va-xuat-du-lieu/index.html.ef6e11684dfcb7f6b992aba2c8e21426.json"


/*****************
 ** WEBPACK FOOTER
 ** ./content/generated/29936.md
 ** module id = 534
 ** module chunks = 0
 **/